import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';

import './Tournaments.styles.scss';

const Tournaments = ({ data }) => {
	return (
		<div className="tournamentsScreen">
			<div className="notice">
				<div>
					<motion.img
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 1 }}
						src="/assets/pr-league.png"
					/>
				</div>
				<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
					<h3 className="title">No active tournaments and challenges.</h3>
					<div className="desc">Tournaments, challenges and 1 V 1 games coming soon.</div>
				</motion.div>
			</div>
		</div>
	);
};

export default Tournaments;
